const fries = [
    {
        item: "Philly Cheesesteak Fries",
        ingredients: "seasoned fries topped w/ steak, bell peppers, onions, melted cheese, chipotle dressing, & sunny side up egg"
    }, 
    {
        item: "BBQ Brisket Fries",
        ingredients: "seasoned fries topped w/ roasted brisket, grilled onions, cheese, barbecue sauce, & sunny side up egg"
    },
    {
        item: "Side order of Fries",
    }
]

export default fries